"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const number_filter_item_1 = require("./number-filter-item");
class MoneyFilterItem extends number_filter_item_1.NumberFilterItem {
    constructor(id, label, onValueChange, currencyId) {
        super(id, label, onValueChange);
        this.currencyId = currencyId;
    }
    getFilterTreeDto() {
        if (this.valueFrom == null && this.valueTo == null) {
            return null;
        }
        else if (this.valueFrom != null && this.valueTo != null) {
            const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
            filterBuilder.filterByMeasure(this.id).between(this.valueFrom, this.valueTo, this.currencyId);
            return filterBuilder.build();
        }
        else if (this.valueFrom != null) {
            const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
            filterBuilder.filterByMeasure(this.id).greaterThanOrEqual(this.valueFrom, this.currencyId);
            return filterBuilder.build();
        }
        else if (this.valueTo != null) {
            const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
            filterBuilder.filterByMeasure(this.id).lessThanOrEqual(this.valueTo, this.currencyId);
            return filterBuilder.build();
        }
    }
}
exports.MoneyFilterItem = MoneyFilterItem;
//# sourceMappingURL=money-filter-item.js.map